import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'
import FrameBlank from '@/layouts/FrameBlank.vue'
import { MENU_LABEL, ROUTE_ROLE_TYPE_NAME } from '@/router/menuHelper/constants'

const BOTH = [ROUTE_ROLE_TYPE_NAME.FIRST_MONEY_BOTH, ROUTE_ROLE_TYPE_NAME.MONEY_TREE_ONLY]

const link: RouteRecordRaw = {
  path: '/center-my-variety',
  name: 'LeyopayVarity',
  component: Layout,
  meta: {
    orderNo: 1000,
    icon: 'ion:tv-outline',
    title: MENU_LABEL.VARITY,
    module: 'SettlementSystem',
    menuOfRoleType: BOTH
  },
  children: [
    // {
    //   name: 'variety-sell-statistics',
    //   path: '/variety-sell-statistics',
    //   component: FrameBlank,
    //   meta: {
    //     title: '品种销售统计',
    //     openInNewWindow: true,
    //     path: '/variety-sell-statistics',
    //     module: 'SettlementSystem',
    //     menuOfRoleType: BOTH
    //   }
    // },
    // {
    //   path: `/variety-warehousing-flow`,
    //   name: 'variety-warehousing-flow',
    //   component: FrameBlank,
    //   meta: {
    //     title: '品种入库流水',
    //     openInNewWindow: true,
    //     module: 'SettlementSystem',
    //     path: '/variety-warehousing-flow',
    //     menuOfRoleType: BOTH
    //   }
    // },
    // {
    //   path: `/sales-report`,
    //   name: 'sales-report',
    //   component: FrameBlank,
    //   meta: {
    //     title: '销售报表',
    //     openInNewWindow: true,
    //     path: `/sales-report`,
    //     module: 'SettlementSystem',
    //     menuOfRoleType: BOTH
    //   }
    // },
    // {
    //   path: '/variety-stock',
    //   name: 'variety-stock',
    //   component: FrameBlank,
    //   meta: {
    //     title: '品种库存',
    //     openInNewWindow: true,
    //     module: 'SettlementSystem',
    //     menuOfRoleType: BOTH,
    //     path: '/variety-stock'
    //   }
    // },
    // {
    //   path: '/account_product',
    //   name: 'account_product',
    //   component: FrameBlank,
    //   meta: {
    //     title: '账号品种信息',
    //     openInNewWindow: true,
    //     module: 'SettlementSystem',
    //     menuOfRoleType: [ROUTE_ROLE_TYPE_NAME.FIRST_MONEY_BOTH],
    //     path: '/account_product'
    //   }
    // }
  ]
}

export default link
